import { createContext } from 'libs/react';
import { useContext } from 'libs/react';
import { React } from 'libs/react';
/**
 * @component LoadingProvider
 * @since 1.0.0
 */
export function LoadingProvider(props) {
    /**
     * @function setLoaded
     * @since 1.0.0
     * @hidden
     */
    function setLoaded(loaded = true) {
        document.body.classList.toggle('loaded', loaded);
    }
    const context = {
        setLoaded
    };
    return (React.createElement(LoadingContext.Provider, { value: context }, props.children));
}
/**
 * @component LoadingContext
 * @since 1.0.0
 */
export const LoadingContext = createContext({
    setLoaded() { }
});
/**
 * @function useLoading
 * @since 1.0.0
 */
export function useLoading() {
    return useContext(LoadingContext);
}
